import { Component, OnInit, Input } from '@angular/core';
import { ClubStateDispatcher } from 'src/app/core/state/club/club.dispatcher';
import { NavController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { EventsService } from 'src/app/shared/services/events/events.service';

@Component({
    selector: 'app-container-title',
    templateUrl: './container-title.component.html',
    styleUrls: ['./container-title.component.scss'],
    standalone: false
})
export class ContainerTitleComponent implements OnInit {
    @Input() title: string;
    clubId: string;

    constructor(
        private clubDispatch: ClubStateDispatcher,
        public navCtrl: NavController,
        public events: EventsService,
        private route: ActivatedRoute,
    ) {}

    ngOnInit() {
        this.clubId = this.route.snapshot.paramMap.get('id');
    }

    activateNullContainer() {
        if (this.title == 'Games' || this.title == 'Free Play') {
            this.navCtrl.navigateBack(`lobby/home`);
        } else {
            this.clubDispatch.activateComponent('games');
            this.navCtrl.navigateBack(`club-lobby/${this.clubId}`);
        }
        this.events.publish('hideHeader', { isHidden: false });
    }
}
